<mat-form-field>
  <mat-label>{{ custControl.label }}</mat-label>
  <input
    matInput
    [formControl]="inputControl"
    [readonly]="isReadonly"
    (blur)="onInputBlur($event)"
  />
</mat-form-field>
